<template>
  <b-modal id="modal-edit-nivel-acceso-mesa" size="md" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <div>
        <span class="font-weight-light"><i class="la la-level-down-alt text-dark"></i> Gestión de Acceso - Mesa</span>
      </div>
    </template>
    <div class="alert alert-info">
      Defina los usuarios que podrán gestionar esta mesa de votación.
    </div>
    <b-form id="frm-edit-nivel-acceso-mesa">
      <div class="row pt-3" v-for="nivel in nivelesAcceso" :key="nivel.nivelAccesoId">
        <div class="col-md-12">
          <label class="font-weight-bold">{{ nivel.nombre }}</label>
          <treeselect :multiple="true" :options="usuarios" placeholder="Buscar usuarios..." v-model="nivel.usuariosId"></treeselect>
        </div>
      </div>
    </b-form>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-ban"></i> Cancelar</button>
      <button type="button" class="btn btn-primary font-weight-bold" @click.prevent="doSave()"><i class="fa fa-save"></i> Guardar</button>
    </template>
  </b-modal>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "edit-nivel-acceso-mesa",
  props: {
    value: { type: Boolean, required: true },
    mesaVotacionId: { type: Number },
  },
  data: () => ({
    mostrarModal: true,
    nivelesAcceso: [],
    usuarios: [],
  }),
  methods: {
    handleModalClose(event) {
      if (event) event.preventDefault();
      this.mostrarModal = false;
    },
    async doSave() {
      if (!(await this.sweetConfirm("¿Desea guardar los datos?"))) return;
      if (!this.isFormValid("frm-edit-nivel-acceso-mesa")) return this.sweetAlert("Hay campos con valores incorrectos. Revise los datos ingresados.");

      var model = {
        LocalVotacionMesaId: this.mesaVotacionId,
        ListNivelAccesoMesaVotacion: this.nivelesAcceso,
      };

      await this.$http.post(this.apiRoute("AccessLevel", "EditNivelAccesoMesaVotacion"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.sweetAlert(response.body.message, "success");
          this.$emit("onSave", { mesaVotacionId: this.mesaVotacionId });
          this.mostrarModal = false;
        }
      }, this.mostrarMensajeExcepcionVueResource);
    },
    fetchNivelAcceso() {
      this.$http.get(this.apiRoute("AccessLevel", "GetNivelAccesoMesaVotacionEdit"), { params: { LocalVotacionMesaId: this.mesaVotacionId } }).then(function(response) {
        this.nivelesAcceso = response.body.data;
      });
    },
    fetchUsuarios() {
      this.$http.post(this.apiRoute("User", "ListUsuarios"), { paging: false }).then(function(response) {
        this.usuarios = response.body.data.items.map(function(x) {
          return { id: x.usuarioId, label: x.nombreCompleto };
        });
      });
    },
  },
  watch: {
    mostrarModal(newValue) { this.$emit("input", newValue); },
  },
  mounted() {
    this.mostrarModal = this.value;
    this.initParsley();
    this.fetchUsuarios();
    this.fetchNivelAcceso();
  },
};
</script>
